export default function initBanner() {
    const $scaleElements = document.querySelectorAll('.block-banner img');

    $scaleElements.forEach($element => {
        new ScaleOnScroll($element as HTMLElement);
    });
}

class ScaleOnScroll {
    private element: HTMLElement;
    private observer: IntersectionObserver;
    private maxScale: number = 1.1;
    private minScale: number = 1;

    constructor(element: HTMLElement) {
        this.element = element;
        this.onScroll = this.onScroll.bind(this);
        this.onIntersection = this.onIntersection.bind(this);

        // Configure l'IntersectionObserver
        this.observer = new IntersectionObserver(this.onIntersection, {
            threshold: [0, 1]
        });

        this.observer.observe(this.element);
    }

    /**
     * Callback de l'IntersectionObserver
     * @param {IntersectionObserverEntry[]} entries
     */
    private onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Ajoute l'événement scroll uniquement si l'élément est visible
                document.addEventListener('scroll', this.onScroll);
                this.applyScale(); // Applique immédiatement le scale
            } else {
                document.removeEventListener('scroll', this.onScroll);
                this.resetScale(); // Réinitialise le scale quand l'élément sort de la vue
            }
        });
    }

    /**
     * Applique le scale en fonction du scroll
     */
    private onScroll() {
        this.applyScale();
    }

    /**
     * Calcule et applique le scale sur l'élément
     */
    private applyScale() {
        const rect = this.element.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calcule la progression de l'élément dans la vue (0 à 1)
        const elementProgress = Math.min(Math.max(1 - (rect.top / windowHeight), 0), 1);

        // Calcule le scale basé sur cette progression
        const scaleValue = this.maxScale - (elementProgress * (this.maxScale - this.minScale));
        
        // Applique la transformation de scale
        this.element.style.transform = `scale(${scaleValue})`;
    }

    /**
     * Réinitialise le scale à sa valeur initiale
     */
    private resetScale() {
        this.element.style.transform = `scale(${this.minScale})`;
    }
}
